import { ButtonLinkProps, ButtonLink, Comp } from '@redsift/design-system';
import React, { forwardRef } from 'react';
import { Tooltip } from './Tooltip';
import { TooltipProps } from './types';
import { TooltipTriggerProps } from '../tooltip-trigger';
import { TooltipContentProps } from '../tooltip-content';

export const ButtonLinkWithTooltip: Comp<
  {
    tooltip: string;
    tooltipProps?: TooltipProps;
    tooltipTriggerProps?: Omit<TooltipTriggerProps, 'ref'>;
    tooltipContentProps?: Omit<TooltipContentProps, 'ref'>;
  } & Omit<ButtonLinkProps, 'ref'>,
  HTMLAnchorElement
> = forwardRef(({ tooltip, tooltipProps, tooltipTriggerProps, tooltipContentProps, ...props }, ref) => (
  <Tooltip {...tooltipProps}>
    <Tooltip.Trigger {...tooltipTriggerProps}>
      <ButtonLink aria-label={tooltip} {...props} aria-describedby={undefined} ref={ref} />
    </Tooltip.Trigger>
    <Tooltip.Content {...tooltipContentProps}>{tooltip}</Tooltip.Content>
  </Tooltip>
));
ButtonLinkWithTooltip.displayName = 'ButtonLink';
